var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('farm-main',[_c('home-widgets',{attrs:{"modules":_vm.modules,"logs":_vm.filteredLogs,"assets":_vm.assets,"userId":_vm.userId},on:{"set-module-filters":_vm.setModuleFilters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }